import axios from "axios";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ImCheckmark, ImLoop2 } from "react-icons/im";



const FormContainer = styled.form`
  width: 1000px;
  background-color: #fff;
  padding: 20px 10px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 5px;
  margin: 0 auto; 
  flex-direction: row;

`;

const Div = styled.td`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const InputArea = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  padding: 10px;

  select {
    width: 200px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 1px;
    height: 37px;
  }



`;
const InputArea2 = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-left: 30px;


`;


const Input = styled.input`
  width: 200px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 1px;
  height: 37px;

  
`;

const Input2 = styled.input`
  width: 300px;
  padding: 0 5px;
  border: 1px solid #bbb;
  border-radius: 1px;
  height: 37px;

  
`;



const Label = styled.label`
  color: #4f4f4f;
  font-weight: bold;
  font-size: 17px;  
`;

const ButtonContainer = styled.div`
  width: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  margin: 1px 1px 1px 1px;
 
`;



const Button = styled.button`
  cursor: pointer;
  border: none;
  background-color:   #fff;
  font-weight: bold;
  font-size: 17px;
  margin: 8px;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.1);
  }
  
`;

const Div2 = styled.td`
  display: flex;
 
`;

const Div3 = styled.td`
  display: flex;
  align-items: center;
  flex-direction: rows;
 
`;





const Form = ({ onEdit, urlApi, modulos, setOnEdit, fetchPagina }) => {

  const ref = useRef();

  // tokens
  const token = localStorage.getItem('token');


  //-------------------------------------------EDITAR AS PAGINAS EXISTENTES-----------------------------------------------//


  //onEdit que vem do Grid para ser editado
  useEffect(() => {
    if (onEdit) {

      const user = ref.current;

      user.id_modulo.value = onEdit.ID_MODULO;
      user.desc_pagina.value = onEdit.DESC_PAGINA;
      user.url.value = onEdit.URL;
    };
  }, [onEdit]);


  //--------------------------------------------APLICA A ROTA POST/PUT----------------------------------------------//



  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const id_modulo = form.id_modulo.value;
    const desc_pagina = form.desc_pagina.value.trim();
    const url = form.url.value.trim();

    if (!id_modulo || !desc_pagina || !url) {
      return toast.warn("Preencha todos os campos.");
    }

    const dados = {
      id_modulo,
      desc_pagina,
      url,
    };

    const isEdit = !!onEdit;
    const method = isEdit ? "put" : "post";
    const urlRequisicao = isEdit
      ? `${urlApi}gestao/paginas/${onEdit.ID_PAGINA}`
      : `${urlApi}gestao/paginas`;

    try {
      const response = await axios({
        method,
        url: urlRequisicao,
        data: dados,
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(response.data);
      form.reset();
      setOnEdit(null);
      fetchPagina();
    } catch (error) {
      console.error("Erro ao salvar página:", error);
      toast.error("Erro ao salvar a página.");
    }
  };









  return (
    <>
      <FormContainer ref={ref} onSubmit={handleSubmit}>
        <Div>
          <Div3>
            <InputArea>
              <Label>Modulo:</Label>
              <Div3>
                <select
                  name="id_modulo"

                >
                  <option value="">Escolha uma opção</option>
                  {modulos.map((mod) => (
                    <option key={mod.ID_MODULO} value={mod.ID_MODULO}>
                      {mod.DESC_MODULO}
                    </option>
                  ))}
                </select>

              </Div3>

            </InputArea>
            <InputArea2>
              <Label title="Crie um nome para o link,
              esse nome, será o nome que irá aparecer no painel">Descrição da página:</Label>
              <Div3>
                <Input name="desc_pagina" type="text" ></Input>
              </Div3>
            </InputArea2>

            <InputArea2>
              <Label> Link da página nova:</Label>
              <Div3>
                <Input2 name="url" type="text" ></Input2>
              </Div3>
            </InputArea2>


          </Div3>



          <Div2>
            <ButtonContainer>

              <Button title="Salvar" type="submit">
                <ImCheckmark color={"green"} /> Salvar
              </Button>
            </ButtonContainer>
          </Div2>

        </Div>
      </FormContainer>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </>
  );
};

export default Form;


